import React from 'react';

import pdf1 from '../images/Adobe_PDF_file_icon_32x32.png'; // Adjust the path as necessary
import pdf2 from '../images/Adobe_PDF_file_icon_32x32.png';
import pdfFile1 from '../pdf/pdf1.pdf'; // Adjust the path as necessary
import pdfFile2 from '../pdf/pdf2.pdf';


const AnnualReport = () => {
  return (
   <>

<section className="our-story-section inner-page">
            <div className="container">
                <h1>Financial Reports 2023-24</h1>
     
    <div className='row'>
    <div className='col-md-6'>
     <a target="_blank" href={pdfFile1} > <img className='pdfimg' src={pdf1} alt=""></img></a>

</div>
<div className='col-md-6'>
<a  target="_blank" href={pdfFile2}  > <img className='pdfimg' src={pdf2} alt=""></img></a>

</div>

    </div>
      </div>
      
     
      <br></br>
        
      <br></br>
        
      <br></br>
     
      </section>
   
   </>
   );
  };
 

export default AnnualReport
